

import useVuelidate from '@vuelidate/core'
import { required, minLength, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.contactTitle}`,
            meta: this.infoGenerales?.attributes?.contactMeta != null && this.infoGenerales?.attributes?.contactMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.contactMeta?.replace('\n', '')) : null
        };
        // return {
        //     title: `ICFA - CONTACTEZ NOUS`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: 'Contactez-nous',
        //         },
        //         {
        //             hid: 'og-description',
        //             property: 'og:description',
        //             content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         }
        //     ]
        // };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri

        const isOpen = false

        let messageForm = {
            objetcontact: '',
            prenom: '',
            nom: '',
            email: '',
            telephone: '',
            resumeProjet: '',
        };

        let formSent = false;

        let sending = false;

        return {
            strapiBaseUri,
            messageForm,
            departementExplantionNeeded: false,
            formSent, 
            sending,
            isMounted: false,
            isOpen,
        }
    },

    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            messageForm: {
                objetcontact: { required },
                prenom: { required },
                nom: { required },
                email: { required, email },
                telephone: { required, mustBePhoneNumber, minLength: minLength(10) },
            }

        }
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        checkCandidatureForm() {

        },
        async sendStudent() {
            try{
                if (await this.v$.$validate()) {
                    this.sending = true;
                    this.messageForm.url = window.location.host + "" + this.$nuxt.$route.path;

                    let formData = new FormData();
                    formData.append('data', JSON.stringify(this.messageForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}contact.php?`, formData);
                    if (result == "success") {
                        this.formSent = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }
                }
            }catch(error){
                this.sending = false;
                this.isOpen = true
            }

        },
    },
    async asyncData({ params, store }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));


        return {
            params, instances, infoGenerales
        }
    },
}


